import React, { Component } from 'react';
import ImageUploader from 'react-images-upload';
import {showModalPageClass, hideModalPageClass, toBase64} from '../../functions';
import {toast } from 'react-toastify';

export default class ModalFile extends Component {

    state = {
        fileSelecionado: '',
        btnSeleccionarDisplay: 'none',
        fileData: '',
        accept: '',
        imgExtension: [],
        formatosAceptados: ''
    }

    constructor(props) {
        super(props);

        if(this.props.tipo === 'doc'){
            this.state.accept               = '.doc,.docx,.pdf,.ppt,.pttx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            this.state.imgExtension         = ['.doc', '.docx', '.pdf', '.ppt', '.pttx'];
            this.state.formatosAceptados    = 'DOC - DOCX - PDF - PPT - PPTX';
        }else if(this.props.tipo === 'image'){
            this.state.accept               = 'image/*';
            this.state.imgExtension         = ['.jpg', '.jpeg', '.gif', '.png', '.gif'];
            this.state.formatosAceptados    = 'jpg - jpeg - gif - png';
        }
    }
    
    salirGestorMultimedia = () => {
        hideModalPageClass("divGestorArchivos");
    }

    handleCancelar(){
        hideModalPageClass("divGestorArchivos");
    }

    handleSeleccionar(){
        this.props.onSelect(this.state.fileSelecionado, this.state.fileData);
        hideModalPageClass("divGestorArchivos");
    }

    onSelectFile = (files) => {
        if(files.length > 0){
            let file = files[files.length - 1];

            if(file){
                toBase64(file).catch(e => {
                    toast.error("Ocurrió un error al analizar el archivo, por favor seleccione otro")
                }).then(data => {
                    this.setState({
                        btnSeleccionarDisplay: '',
                        fileSelecionado: file.name,
                        fileData: data
                    })
                });
            }
        }
    }

    render() {
        return (
            <div className={"divGestorArchivos " + this.props.class} style={{display:"none"}}>
                <div className="divLayerPopup_GestorArchivos">
                    <div className="divPopup_GestorArchivos">
                        <div className="divClosePopup_GestorArchivos" onClick={() => this.salirGestorMultimedia()} />
                        <h2>Gestor de Archivos </h2>
                        <div className="divWrapperGestorArchivos">
                            <ImageUploader
                                accept={this.state.accept} 
                                imgExtension={this.state.imgExtension}
                                onChange={(files) => this.onSelectFile(files)}
                                buttonText='Click para elegir'
                                label={`Formatos aceptados: ${this.state.formatosAceptados}`}
                                singleImage={true}
                                withIcon={false}
                                withPreview={false} 
                                maxFileSize={15242880} />
                            <label><strong>Seleccionado: {this.state.fileSelecionado}</strong></label>
                            <div className="divBtnGestorArchivos">
                                <a href="#" className="noneEvent formNuevoArchivo" style={{display: this.state.btnSeleccionarDisplay}} onClick={() => this.handleSeleccionar()}>SELECCIONAR</a>
                                <a href="#" className="noneEvent volverMain" onClick={() => this.handleCancelar()}>Cancelar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}